import { useQuery } from "@tanstack/react-query";
import { MainTable, BalanceWarehouseDiff } from "components";
import { Main } from "layouts";
import { client_v2, stringifyQuery, parseQuery } from "utils/api";

import { ReactComponent as StationIcon } from "icons/dock.svg";
import { connect } from "react-redux";

const getStockStatusColor = (diff) => {
  if (diff > 0) {
    return { color: " #0abb87" };
  }
  if (diff < 0) {
    return { color: "#fd397a" };
  }

  return {};
};

const WarehouseLocationDiffs = ({ current_user, location: { search } }) => {
  const query = parseQuery(search);
  const sort = {
    "sort[column]": query["sort[column]"] || "id",
    "sort[order]": query["sort[order]"] || "asc",
  };

  const { isLoading: is_loading, data } = useQuery(
    ["warehouse_location_diffs", query],
    () =>
      client_v2.get(`/product_main_locations/diffs?${stringifyQuery(sort)}`),
    {
      select: (res) => res.data,
      retry: false,
    },
  );

  return (
    <Main
      page={{
        name: "Zadania magazynowe",
        icon: <StationIcon />,
        breadcrumbs: [{ name: "Zadania magazynowe" }],
      }}
    >
      <div className="dashboard">
        <MainTable
          is_loading={is_loading}
          is_searching={is_loading}
          data={data}
          sort={sort}
          head={[
            {
              label: "SKU",
              name: "sku",
              style: { width: 200 },
            },
            {
              label: "Ilość magazyn główny",
              name: "main_warehouse_stock",
            },
            {
              label: "Różnica magazyn główny",
              name: "main_warehouse_diff",
            },
            {
              label: "Ilość magazyn wysyłkowy",
              name: "shipment_warehouse_stock",
            },
            {
              label: "Różnica magazyn wysyłkowy",
              name: "shipment_warehouse_diff",
            },
            current_user.can_balance_warehouse_diffs && {
              label: "Akcje",
              name: "actions",
              sortable: false,
              style: { width: 220 },
            },
          ].filter(Boolean)}
          empty_text="Brak danych"
          renderRow={({
            id,
            sku,
            main_warehouse_stock,
            main_warehouse_diff,
            shipment_warehouse_stock,
            shipment_warehouse_diff,
          }) => {
            return (
              <tr key={id}>
                <td>
                  <a
                    className="link"
                    href={`/products/${id}/localization`}
                    target="_blank"
                  >
                    {sku}
                  </a>
                </td>
                <td>{main_warehouse_stock}</td>
                <td>
                  <strong style={getStockStatusColor(main_warehouse_diff)}>
                    {main_warehouse_diff > 0 ? "+" : ""}
                    {main_warehouse_diff}
                  </strong>
                </td>
                <td>{shipment_warehouse_stock}</td>
                <td>
                  <strong style={getStockStatusColor(shipment_warehouse_diff)}>
                    {shipment_warehouse_diff > 0 ? "+" : ""}
                    {shipment_warehouse_diff}
                  </strong>
                </td>
                {current_user.can_balance_warehouse_diffs && (
                  <td>
                    <BalanceWarehouseDiff
                      productId={id}
                      mainWarehouseDiff={main_warehouse_diff}
                      shipmentWarehouseDiff={shipment_warehouse_diff}
                    />
                  </td>
                )}
              </tr>
            );
          }}
        />
      </div>
    </Main>
  );
};

export default connect(({ current_user }) => ({ current_user }))(
  WarehouseLocationDiffs,
);
